import { IconProps } from './types';

const CustomerBorderIcon = (props: IconProps) => {
  const { width = '16', height = '16', fillColor = 'var(--blue-base)' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <rect
        x="0.25"
        y="0.25"
        width="15.5"
        height="15.5"
        rx="7.75"
        stroke={fillColor}
        strokeWidth="0.5"
      />
      <mask
        id="mask0_923_25410"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_923_25410)">
        <path
          d="M7.99984 7.99996C7.2665 7.99996 6.63873 7.73885 6.1165 7.21663C5.59428 6.6944 5.33317 6.06663 5.33317 5.33329C5.33317 4.59996 5.59428 3.97218 6.1165 3.44996C6.63873 2.92774 7.2665 2.66663 7.99984 2.66663C8.73317 2.66663 9.36095 2.92774 9.88317 3.44996C10.4054 3.97218 10.6665 4.59996 10.6665 5.33329C10.6665 6.06663 10.4054 6.6944 9.88317 7.21663C9.36095 7.73885 8.73317 7.99996 7.99984 7.99996ZM3.99984 13.3333C3.63317 13.3333 3.31939 13.2028 3.0585 12.942C2.79717 12.6806 2.6665 12.3666 2.6665 12V11.4666C2.6665 11.0888 2.76384 10.7415 2.9585 10.4246C3.15273 10.1082 3.41095 9.86663 3.73317 9.69996C4.42206 9.35552 5.12206 9.09707 5.83317 8.92463C6.54428 8.75263 7.2665 8.66663 7.99984 8.66663C8.73317 8.66663 9.45539 8.75263 10.1665 8.92463C10.8776 9.09707 11.5776 9.35552 12.2665 9.69996C12.5887 9.86663 12.8469 10.1082 13.0412 10.4246C13.2358 10.7415 13.3332 11.0888 13.3332 11.4666V12C13.3332 12.3666 13.2027 12.6806 12.9418 12.942C12.6805 13.2028 12.3665 13.3333 11.9998 13.3333H3.99984Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default CustomerBorderIcon;
